import * as Yup from 'yup';

export const validationSchema = Yup.object({
    financo: Yup.string().notRequired(),
    preferences: Yup.object().notRequired(),
});
